import { render, staticRenderFns } from "./AddFriend.vue?vue&type=template&id=c091a604&scoped=true"
import script from "./AddFriend.vue?vue&type=script&lang=js"
export * from "./AddFriend.vue?vue&type=script&lang=js"
import style0 from "./AddFriend.vue?vue&type=style&index=0&id=c091a604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c091a604",
  null
  
)

export default component.exports